import Countdown, { zeroPad } from "react-countdown";
import { AiFillClockCircle } from "react-icons/ai";

import {
    PRESALE_INPROGRESS,
    PRESALE_ENDED,
    PRESALE_UPCOMING,
} from "../../utils/constants";

const TokenTimer = ({
    status,
    presaleStartTime,
    presaleEndTime,
    lockupTime,
    icon = true,
    className,
    styledTimer = false,
}) => {
    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span>You are good to go!</span>;
        } else {
            // Render a countdown
            return (
                <div className="flex gap-1">
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(days)}
                    </span>
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(hours)}
                    </span>
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(minutes)}
                    </span>
                    <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                        {zeroPad(seconds)}
                    </span>
                </div>
            );
        }
    };

    let gap = presaleStartTime - new Date().getTime() / 1000;
    if (status === PRESALE_UPCOMING)
        gap = presaleStartTime - new Date().getTime() / 1000;
    else if (status === PRESALE_INPROGRESS)
        gap = presaleEndTime - new Date().getTime() / 1000;
    else if (status === PRESALE_ENDED)
        gap = lockupTime - new Date().getTime() / 1000;
    else gap = lockupTime - new Date().getTime() / 1000; //if (status === PRESALE_INPROGRESS)

    const statusText = {
        PRESALE_UPCOMING: "Starts in",
        PRESALE_INPROGRESS: "Ends in",
        PRESALE_FINALISED: "Sale finalised",
        PRESALE_ENDED: "Unlocked in",
        LIQUIDITY_UNLOCKED: "Liquidity unlocked",
        PRESALE_CANCELED: "Canceled",
        PRESALE_FILLED: "Hardcap Filled",
        PRESALE_ENDED_NOT_MET_SOFTCAP: "Cancelled",
    };
    let statusTimer = {
        PRESALE_UPCOMING: "show",
        PRESALE_INPROGRESS: "show",
        PRESALE_ENDED: "show",
        LIQUIDITY_UNLOCKED: "",
    };
    return (
        <div className={className || "flex justify-between w-full"}>
            <span className="flex items-center opacity-70">
                {icon && (
                    <AiFillClockCircle className="size-1 mr-1 text-black dark:text-[#CDCDCD]" />
                )}
                {statusText[status]}
            </span>
            {statusTimer[status] && (
                <Countdown date={Date.now() + gap * 1000} renderer={renderer} />
            )}
        </div>
    );
};

export default TokenTimer;
